// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__NJJMF","footerText":"Footer_footerText__kTWTV","companyName":"Footer_companyName__yfGfH","poweredBy":"Footer_poweredBy__NtIqo"};